type DocumentFields = {
  governmentIdFile?: string | null
  powerOfAttorneyFile?: string | null
  addressProofFile?: string | null
  constitutiveActFile?: string | null
  riskAssessmentReportFile?: string | null
  analysisReportFile?: string | null
  siteInspectionReportFile?: string | null
  promissoryNoteFile?: string | null
}

export const calculateFilledPercentage = (
  documents: DocumentFields,
): number => {
  const keys = Object.keys(documents) as (keyof DocumentFields)[]
  const total = keys.length

  const filled = keys.filter((key) => {
    const value = documents[key]
    return value !== null && value !== undefined && value !== ''
  }).length

  return (total === 0 ? 0 : filled / total) * 100
}
